<mat-form-field class="w-full">
    <mat-label>
        @if (typeof label === 'string') {
            {{ label }}
        } @else {
            <apcam-translation [model]="label" />
        }
    </mat-label>
    <mat-select
        [formControlName]="formcontrolName"
        [(value)]="selectedValue"
        [placeholder]="
            displayedCountryList().length > 0
                ? ('shared.selectCountry.placeholder' | translate)
                : ('shared.selectCountry.noCountriesAvailable' | translate)
        ">
        @if (selectedValue) {
            <mat-select-trigger class="pt-2">
                <div class="flex gap-2 items-center">
                    <apcam-flag
                        [altText]="
                            ('shared.selectCountry.flagIcon' | translate) +
                            getCountryName(selectedValue)
                        "
                        [flagCode]="selectedValue" />
                    {{ getCountryName(selectedValue) }}
                </div>
            </mat-select-trigger>
        }
        @for (country of displayedCountryList(); track country.code) {
            <mat-option [value]="country.code">
                <div class="flex gap-2 items-center">
                    <apcam-flag
                        [altText]="
                            ('shared.selectCountry.flagIcon' | translate) +
                            country.name
                        "
                        [flagCode]="country.code"></apcam-flag>
                    {{ country.name }}
                </div>
            </mat-option>
        }
    </mat-select>
    @if (input?.hasError('required')) {
        <mat-error>
            {{ 'shared.validation.required' | translate }}
        </mat-error>
    }
</mat-form-field>
